import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=ec8e56ee&scoped=true"
import script from "./Investment.vue?vue&type=script&lang=js"
export * from "./Investment.vue?vue&type=script&lang=js"
import style0 from "../../components/Formulario/formularioNuevo.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Investment.vue?vue&type=style&index=1&id=ec8e56ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8e56ee",
  null
  
)

export default component.exports